import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

import { Navbar, Footer, Sidebar, ThemeSettings } from "./components";
import {
  Ecommerce,
  Calendar,
  Employees,
  Stacked,
  Pyramid,
  Customers,
  Kanban,
  Line,
  Area,
  Bar,
  Pie,
  Financial,
  ColorPicker,
  ColorMapping,
  Editor,
} from "./pages";
import "./App.css";
import axios from "axios";
import { baseUrl } from "./data/baseURL";

import { useStateContext } from "./contexts/ContextProvider";
import AuthPage from "./pages/loginPage";
import Mizban from "./pages/Mizban";
import Khademi from "./pages/Khademi";
import Hossein from "./pages/Hossein";
import Bashgah from "./pages/Bashgah";
import Post from "./pages/Posts";
import Amanat from "./pages/Amanat";
import AmanatList from "./pages/AmanatList";
import CreateCall from "./pages/Calls/CreateCall";
import CallReports from "./pages/Calls/CallReports";
import EditCall from "./pages/Calls/EditCall";
import CategoriesManagement from "./pages/Calls/CategoriesManagement";
import UserManagement from "./pages/UserManagement/UserManagement";

const App = () => {
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    currentColor,
    themeSettings,
    setThemeSettings,
  } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, []);
  
  const [profile, setProfile] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseUrl}/Auth`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setProfile(response.data.data);
      } catch (error) {
        console.error("Error fetching data from API", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className={currentMode === "Dark" ? "dark" : ""} dir="rtl">
      <BrowserRouter>
        <div className="flex relative dark:bg-main-dark-bg">
          {token && (
            <div className="fixed end-4 bottom-4" style={{ zIndex: "1000" }}>
              <TooltipComponent content="Settings" position="Top">
                <button
                  type="button"
                  onClick={() => setThemeSettings(true)}
                  style={{ background: currentColor, borderRadius: "50%" }}
                  className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
                >
                  <FiSettings />
                </button>
              </TooltipComponent>
            </div>
          )}
          {token &&
            (activeMenu ? (
              <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
                <Sidebar profile={profile} />
              </div>
            ) : (
              <div className="w-0 dark:bg-secondary-dark-bg">
                <Sidebar profile={profile} />
              </div>
            ))}
          <div
            className={
              activeMenu && token
                ? "dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ms-72 w-full  "
                : "bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 "
            }
          >
            {token && (
              <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
                <Navbar profile={profile} />
              </div>
            )}
            <div>
              {themeSettings && token && <ThemeSettings />}

              <Routes>
                <Route
                  path="/login"
                  element={token ? <Navigate to="/ecommerce" /> : <AuthPage />}
                />
                <Route
                  path="/"
                  element={!token ? <Navigate to="/login" /> : <Ecommerce />}
                />
                <Route
                  path="/ecommerce"
                  element={!token ? <Navigate to="/login" /> : <Ecommerce />}
                />
                <Route
                  path="/paye-kare-hossein"
                  element={!token ? <Navigate to="/login" /> : <Hossein />}
                />

                {/* pages  */}
                <Route
                  path="/mizban"
                  element={!token ? <Navigate to="/login" /> : <Mizban />}
                />
                <Route
                  path="/Khademi"
                  element={!token ? <Navigate to="/login" /> : <Khademi />}
                />
                <Route
                  path="/customers"
                  element={!token ? <Navigate to="/login" /> : <Customers />}
                />
                <Route
                  path="/bashgah"
                  element={!token ? <Navigate to="/login" /> : <Bashgah />}
                />
                <Route
                  path="/posts"
                  element={!token ? <Navigate to="/login" /> : <Post />}
                />
                <Route
                  path="/create-amanat"
                  element={!token ? <Navigate to="/login" /> : <Amanat />}
                />
                <Route
                  path="/edit-amanat"
                  element={!token ? <Navigate to="/login" /> : <Amanat />}
                />
                <Route
                  path="/amanat-list"
                  element={!token ? <Navigate to="/login" /> : <AmanatList />}
                />
                <Route
                  path="/create-call"
                  element={!token ? <Navigate to="/login" /> : <CreateCall />}
                />
                <Route
                  path="/call-reports"
                  element={!token ? <Navigate to="/login" /> : <CallReports />}
                />
                <Route
                  path="/edit-call"
                  element={!token ? <Navigate to="/login" /> : <EditCall />}
                />
                <Route
                  path="/categoris-management"
                  element={!token ? <Navigate to="/login" /> : <CategoriesManagement />}
                />
                <Route
                  path="/users-management"
                  element={!token ? <Navigate to="/login" /> : <UserManagement />}
                />
                {/* apps  */}
                <Route
                  path="/create-post"
                  element={!token ? <Navigate to="/login" /> : <Editor />}
                />
                <Route
                  path="/editor"
                  element={!token ? <Navigate to="/login" /> : <Editor />}
                />
                <Route
                  path="/calendar"
                  element={!token ? <Navigate to="/login" /> : <Calendar />}
                />
                <Route
                  path="/color-picker"
                  element={!token ? <Navigate to="/login" /> : <ColorPicker />}
                />

                {/* charts  */}
                <Route
                  path="/line"
                  element={!token ? <Navigate to="/login" /> : <Line />}
                />
                <Route
                  path="/area"
                  element={!token ? <Navigate to="/login" /> : <Area />}
                />
                <Route
                  path="/bar"
                  element={!token ? <Navigate to="/login" /> : <Bar />}
                />
                <Route
                  path="/pie"
                  element={!token ? <Navigate to="/login" /> : <Pie />}
                />
                <Route
                  path="/financial"
                  element={!token ? <Navigate to="/login" /> : <Financial />}
                />
                <Route
                  path="/color-mapping"
                  element={!token ? <Navigate to="/login" /> : <ColorMapping />}
                />
                <Route
                  path="/pyramid"
                  element={!token ? <Navigate to="/login" /> : <Pyramid />}
                />
                <Route
                  path="/stacked"
                  element={!token ? <Navigate to="/login" /> : <Stacked />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
